import Table, { OriginalRow, TableColumn, TableProps } from './Table';

export default Table;
export type { OriginalRow, TableColumn, TableProps };
